<template>
  <div id="admin">
    <menu-admin/>
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="title text-center">
              <i class="fa fa-order"></i>
              <span>Novo Pedido</span>
            </h1>
          </div>
        </div>
      </div>
    </div>

    <section class="int-form">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <form>

              <div class="card-details">
                <h3 class="title">Detalhes novo do pedido</h3>
                <div class="row">
                  <div class="form-group col-sm-12">
                    <label>Cliente</label>
                    <v-select v-model="profile_selected" :options="profile_options"  @search="profile_search">
                      <div slot="no-options">Nenhum cliente encontrado</div>
                    </v-select>
                  </div>
                  <div class="form-group col-sm-12">
                    <label>Publicações</label>
                    <br/>
                    <v-select multiple :filterable="false" v-model="publication_selected" :options="publication_options" @search="publications_search">
                      <div slot="no-options">Nenhuma publicação encontrada!</div>
                    </v-select>
                  </div>
                </div>
              </div>

              <div class="card-details" v-if="publication_selected && publication_selected.length > 0">
                <h3 class="title">Publicações selecionadas</h3>
                <div v-for="(publication, k) in publication_selected" v-bind:key="k">
                  <div class="row">
                    <div class=" col-sm-12">
                      <h6>{{publication.label}}</h6>
                    </div>
                    <span v-for="(item, i) in publication.items" class="row" style="padding: 10px 20px; width: 100%; position: relative" v-bind:key="i">
                      <a v-if="i > 0" href="javascript:;" style="font-size: 0.7em; position: absolute; top: 55px; left: 10px; color: red" @click="removeItem(k, i)"><small>X</small></a>
                      <div class="form-group col-sm-3">
                        <label>Preço</label>
                        <select class="form-control" v-model="item.value">
                          <option :value="publication.price">R$ {{publication.price | formatPrice}}</option>
                          <option :value="publication.price_signature">Assinatura: R$ R$ {{publication.price_signature | formatPrice}}</option>
                          <option value="0.00">Gratuito: R$ 0,00</option>
                        </select>
                      </div>
                      <div v-show="publication.has_airplane_info" class="form-group col-sm-3">
                        <label>Prefixo da aeronave</label>
                        <input class="form-control" v-mask="'AA-AAA'" type="text" v-model="item.airplane_prefix"/>
                      </div>
                      <div v-show="publication.has_airplane_info" class="form-group col-sm-3">
                        <label>Numero de série</label>
                        <input class="form-control" type="text" v-model="item.airplane_serial_number"/>
                      </div>
                      <div v-show="publication.has_airplane_info" class="form-group col-sm-3">
                        <label>Tipo de Combustível</label>
                        <select class="form-control" v-model="item.fuel_type">
                          <option :value="0">Não Informado</option>
                          <option :value="1">Gasolina</option>
                          <option :value="2">Etanol</option>
                          <option :value="3">Convertido para Etanol</option>
                        </select>
                      </div>

                      </span>
                      <a href="javascript:;" class="col-sm-12 text-right" style="font-size: 0.7em;" @click="addItem(k)">Adicionar novo ítem</a>
                  </div>

                  <hr/>
                </div>

              </div>

              <hr/>
              <div class="card-details" style="padding-top: 0">
                <div class="row">
                  <div class="form-group col-sm-12">
                    <div id="sucessUpdate" class="alert alert-success text-center" role="alert" style="display: none;">As informações foram salvas com sucesso</div>
                    <div id="errorFound" class="alert alert-danger text-center" role="alert" style="display: none">Um erro foi encontrado. Verifique os campos do formulário</div>
                    <button type="button" class="btn btn-secondary" onclick="window.history.back()">Voltar</button>
                    <button type="button" class="btn btn-primary pull-right" @click="saveorder()">Salvar</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <footer-admin/>
  </div>
</template>

<script>
  import user from "../../api/user"
  import publication from "../../api/publication"
  import order from "../../api/order"
  import menuAdmin from "../admin/common/menu-admin"
  import footerAdmin from "../admin/common/footer-admin"
  import mixins from "../../helpers/mixins"

  export default {
    name: "AdminOrdersCreateView",
    mixins: [mixins],
    components: { menuAdmin, footerAdmin },
    data(){ return{
      order: { },
      publication_selected: [],
      profile_selected: null,
      profile_options: [],
      publications: [],
      publication_options: [],
      users: []
    }},
    methods: {
      addItem(k){
        this.publication_selected[k]['items'].push({
                  "airplane_prefix": "",
                  "airplane_serial_number": "",
                  "fuel_type": 0,
                  "file": "",
                  "value": this.publication_selected[k].price
                })
      },
      removeItem(k, i){
        this.publication_selected[k]['items'].splice(i, 1);
      },
      saveorder(){
        $("#sucessUpdate").hide();
        let send_publications = []

        for (let pub_key in this.publication_selected){
          for (let item_key in this.publication_selected[pub_key]['items']){
            send_publications.push({
              publication: this.publication_selected[pub_key].publication,
              value: this.publication_selected[pub_key]['items'][item_key].value,
              airplane_prefix: this.publication_selected[pub_key]['items'][item_key].airplane_prefix,
              airplane_serial_number: this.publication_selected[pub_key]['items'][item_key].airplane_serial_number,
              fuel_type: this.publication_selected[pub_key]['items'][item_key].fuel_type,
              file: ''
            })
          }
        }

        let create_data = {
          "profile": this.profile_selected.id,
          "shipping_type": 'Pedido Interno',
          "shipping_value": 0.01,
          "publications": send_publications
        };

        order.create(create_data).then((response) => {
          if(response.status === 201){
            this.redirectURL('/admin/orders')
          } else {
            alert('ATENÇÃO: Não foi possivel criar seu pedido');
          }
        }).catch(errors => { this.formErrors(errors) })
      },
      publications_search(search, loading) {
        loading(true);
        publication.list(1, search).then((response)  =>  {
          this.publications = response.data.results

          let options = []
          this.publications.forEach(function(item){
            options.push({
              "label": item.name,
              "price": item.price,
              "price_signature": item.price_signature,
              "items": [
                {
                  "airplane_prefix": "",
                  "airplane_serial_number": "",
                  "fuel_type": 0,
                  "file": "",
                  "value": item.price
                }
              ],
              "publication": item.id,
              "has_airplane_info": item.has_airplane_info
            })
          })
          this.publication_options = options
          loading(false);
        })
      },
      profile_search(search, loading) {
        loading(true);
        user.list(1, search).then((response)  =>  {
          this.users = response.data.results

          let options = []
          this.users.forEach(function(item){
            let name = null
            if(item.person_or_company){
              name = item.company_name
            } else {
              name = item.name
            }
            options.push({
              "label": name,
              "id": item.id
            })
          })
          this.profile_options = options
          loading(false);
        })
      },
    }
  }
</script>

<style scoped>
  .jumbotron-fluid{
    padding-top: 100px;
    padding-bottom: 20px;
    margin-bottom: 10px;
  }
</style>
